import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import styles from './contact-card.module.css';
import { Text } from '../../../../components/Text';
import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import ContactPlate from './contact-plate';
import TableActionsContainer from '../../../../components/CustomTable/TableActionsContainer';

const Contacts = ({ message }) => {
  const [showContact, setShowContacts] = useState(false);

  const contacts = message?.contacts || [];
  const isMoreThanOne = contacts.length > 1;

  const handleClick = () => setShowContacts(true);
  const hideDialog = () => setShowContacts(false);

  const firstContactName =
    contacts[0]?.name?.formatted_name || contacts[0]?.phones?.[0]?.phone || 'Unknown';

  return (
    <>
      <div className="w-full cursor-pointer" onClick={handleClick}>
        <div className="card flex align-items-center">
          <AvatarGroup>
            {contacts.map((_, i) => (
              <Avatar icon="pi pi-user" shape="circle" key={i} />
            ))}
          </AvatarGroup>

          <div className="ml-3">
            {isMoreThanOne ? (
              <Text type="sub-heading">
                {firstContactName} and {contacts.length - 1} other
                {contacts.length - 1 === 1 ? ' contact' : ' contacts'}
              </Text>
            ) : (
              <Text type="sub-heading">{firstContactName}</Text>
            )}
          </div>
        </div>

        {isMoreThanOne && (
          <div className={`text-center ${styles.view_all} my-2 text-sm pt-2`}>View All</div>
        )}
      </div>

      <Dialog
        visible={showContact}
        onHide={hideDialog}
        header={<Text type="heading">View Contacts</Text>}
        className="w-11 md:w-6 lg:w-4"
      >
        <TableActionsContainer>
          {contacts.map((contact, idx) => (
            <ContactPlate key={idx} contact={contact} />
          ))}
        </TableActionsContainer>
      </Dialog>
    </>
  );
};

export default Contacts;
